import { useCurrentFrame, useVideoConfig } from 'remotion';

/**
 * Frame-based typing animation for Remotion video mode.
 * @param {string} fullText - Complete code to display
 * @param {number} typingSpeedMs - Milliseconds per character
 * @param {number} startFrom - Character index to start typing from (previous code length)
 * Returns { text, done, charIndex } based on current frame.
 */
export function useTypingAnimation(fullText, typingSpeedMs = 38, startFrom = 0) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const framesPerChar = Math.max(1, Math.round((typingSpeedMs / 1000) * fps));
  // Only type the new characters (delta from startFrom)
  const newChars = Math.min(Math.floor(frame / framesPerChar), Math.max(0, fullText.length - startFrom));
  const chars = startFrom + newChars;

  return {
    text: fullText.slice(0, chars),
    done: chars >= fullText.length,
    charIndex: chars,
  };
}
